enum CampaignStatus {
  ACTIVE = 'active',
  COMPLETED = 'completed',
  ARCHIVED = 'archived',
  UNPUBLISHED = 'unpublished',
}

export default CampaignStatus;
